import React from "react";

export default function GuidanceBulletList({ items }) {
  return (
    <ul className="list-disc pl-5 flex flex-col gap-2">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
